import { TiTick } from "react-icons/ti";
import BannerSideImage from "../../assets/images/CMS-DevelopmentBanner.png";
import GetAQuoteButton from "../GetAQuoteButton";
 function CustomBanner({
  children,
  svgImg,
  bgImg,
  ariaLabel,
  mobileFullScreenHeight = true,
  bgPosition = "bg-top",
  svgWidth = "w-[11rem]  min-[340px]:w-[15rem]  min-[550px]:w-[20rem] sm:w-[20rem] md:w-[21rem] lg:w-[23rem] xl:w-[25rem] ",
  svgPosition = "-bottom-14 md:top-[65%]  lg:top-[60%] ",
  imgAlt = "",
  BannerImageAlt = "image",
  LinkTitle,
  LinkLabel, 
  customHeight,
  gradientBannerHeight='h-[88vh]  md:h-[35rem]',
gradientBannerParentHeight=' h-screen mb-10 md:pb-52  md:mb-0'
}) { 
  return (
    <>
      {bgImg ? (
        <section 
          className={` relative  bg-cover bg-no-repeat custom-bg  ${bgPosition} ${customHeight && `bg-center h-full min-h-[98vh] mb-32 xl:mb-0 pt-36  md:pt-36 lg:pt-36 pb-[3.6rem]  xl:pb-10 xl:min-h-[98vh]  flex justify-center items-center xl:pt-[130px]`} h-[35rem]`}
          style={{ backgroundImage: `url(${bgImg})` }}
          fetchPriority="high"
          alt={BannerImageAlt} 
        >  
         
          <div className="absolute inset-0 bg-gradient-to-br from-[#000]/80 to-[#000]/40"></div>
          {/* <div className="absolute inset-0 bg-black/30"></div> */}
          {/* <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/40 via-40% to-white/30"></div> */}
          {/* <div className="absolute inset-0 bg-gradient-to-br from-[#6D1349]/20 to-[#DF73FF]/20"></div> */}

          <div className="container relative  h-full container-relative ">
            <div className=" text-white pt-0   flex  items-center h-full text-flex-center ">
              <div className=" space-y-4 md:space-y-6 vertical-spacing w-full">
                {children}

                {svgImg && (
                  <div className="relative z-10 mt-10">
                    <GetAQuoteButton
                      text="Get Started"
                      title="Contact Apptalyst Team"
                    />
                  </div>
                )}
              </div>
            </div>
            {/* svg Image */}

            {svgImg && (
              <div
                className={`absolute right-4 md:right-2 z-10  ${svgPosition}  `}
              >
                <img
                  src={svgImg}
                  alt={imgAlt}
                  width="600"
                  height="400"
                  itemProp="image"
                  className={`${svgWidth}  object-contain`}
                  fetchPriority="high"
                />
              </div>
            )}
          </div>
        </section>
      ) : (
        <section
          role="banner"
          aria-label={ariaLabel}
          className={` ${
            mobileFullScreenHeight
              ? ` ${gradientBannerParentHeight}    `
              : "h-[35rem] "
          } md:h-auto   box-border md:box-content`}
        >
          <div className={` bg-gradient-to-br from-[#6D1349] to-[#DF73FF]  md:pb-4 ${gradientBannerHeight}`}>
            <div className="container relative  h-full ">
              <div className=" text-white   md:pt-20  flex  items-center    h-full ">
                <div className=" space-y-6 md:space-y-6  relative">
                  {children}
                  {svgImg && (
                    <div className="relative z-10 mt-10">
                      <GetAQuoteButton
                        text="Get Started"
                        title="Contact Apptalyst Team"
                      />
                    </div>
                  )}
                </div>
              </div>
              {/* svg Image */}

              {svgImg && (
                <div
                  className={`absolute right-4 md:right-2 z-10  ${svgPosition}  `}
                >
                  <img
                    src={svgImg}
                    alt={imgAlt}
                    width="640px"
                    height="360px"
                    itemProp="image"
                    className={`${svgWidth}  object-contain`}
                    fetchPriority="high"
                  />
                </div>
              )}
            </div>
          </div>
        </section>
      )}
    </>
  );
}

export default CustomBanner;
